import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "show-on-hover"
}

import { computed } from "vue";
import { TraceMatrixChipProps } from "@/types";
import {
  selectionStore,
  subtreeStore,
  traceSaveStore,
  traceStore,
} from "@/hooks";
import { Typography, IconButton, Icon, Chip } from "@/components/common";


/**
 * Renders a chip representing a trace link between two artifacts.
 */
const __default__ = {
  name: "TraceMatrixChip",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    source: {},
    target: {}
  },
  setup(__props: any) {

const props = __props;

const direction = computed(() =>
  subtreeStore.getRelationship(props.source.id, props.target.id)
);

const isChild = computed(() => direction.value === "child");
const doDisplay = computed(() => !!direction.value);

const traceLink = computed(() =>
  isChild.value
    ? traceStore.getTraceLinkByArtifacts(props.target.id, props.source.id)
    : traceStore.getTraceLinkByArtifacts(props.source.id, props.target.id)
);

const isGenerated = computed(() => traceLink.value?.traceType === "GENERATED");

const isUnreviewed = computed(
  () => isGenerated.value && traceLink.value?.approvalStatus === "UNREVIEWED"
);

const className = computed(() => {
  const base = isGenerated.value
    ? "trace-chip-generated text-nodeGenerated "
    : "trace-chip text-nodeDefault ";
  const unreviewed = isUnreviewed.value ? "trace-chip-unreviewed" : "";

  return base + unreviewed;
});

/**
 * Selects the trace link represented by this chip.
 */
function handleClick(): void {
  if (!traceLink.value) return;

  selectionStore.selectTraceLink(traceLink.value);
}

/**
 * Opens the trace creation panel to create a link between these artifacts.
 */
function handleCreateLink(): void {
  traceSaveStore.openPanel({
    type: "both",
    sourceIds: [props.source.id],
    targetIds: [props.target.id],
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (doDisplay.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_unref(Chip), {
            clickable: "",
            outlined: "",
            class: _normalizeClass(className.value),
            onClick: handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), {
                value: _ctx.source.name,
                color: "text"
              }, null, 8, ["value"]),
              _createVNode(_unref(Icon), {
                size: "sm",
                class: "q-mx-xs",
                rotate: isChild.value ? -180 : 0,
                variant: "trace"
              }, null, 8, ["rotate"]),
              _createVNode(_unref(Typography), {
                color: "text",
                value: _ctx.target.name
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["class"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "width-fit",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_unref(IconButton), {
              small: "",
              icon: "add",
              tooltip: "Create trace link",
              onClick: handleCreateLink
            })
          ])
        ]))
  ]))
}
}

})